import React, { useState, useEffect } from 'react'
import { useGetIdentity } from '@pankod/refine-core'
import {
  Table,
  Col,
  List,
  Typography,
  Space,
  DateField,
  Tag,
  Button,
  Modal,
  useModal,
  ModalProps,
  useTable,
  Form,
  Select,
  useForm,
  Popconfirm,
  useImport,
  ImportButton,
  notification,
} from '@pankod/refine-antd'
import AssignPaperToCandidates from './assignPaperToCandidates'
import { ITestEvent, ICandidateRegistration, ITestTrack, IPaper, ITestEventAssignedPapers } from 'interfaces'
import registrationMetaData from 'metadata/candidate_registration'

type Props = {
  testEvent: ITestEvent | undefined
  testTrackList: ITestTrack[] | undefined
  newPapers: IPaper[] | undefined
  oldPapers: ITestEventAssignedPapers[] | undefined
}
type AssignModalProps = {
  testTrackList: ITestTrack[] | undefined
  newPapers: IPaper[] | undefined
  oldPapers: ITestEventAssignedPapers[] | undefined
  modalProps: ModalProps
  close: any
}

const { Text } = Typography

const TestEventCandidates: React.FC<Props> = ({ testEvent, testTrackList, newPapers, oldPapers }) => {
  const { data: user } = useGetIdentity()
  const [testTrack, setTestTrack] = useState<string>('')
  const { close: assignPaperModalClose, show: assignPaperModalShow, modalProps: assignPaperModalProps } = useModal()

  const importProps = useImport({
    paparseOptions: { skipEmptyLines: true },
    resourceName: 'candidate_registration',
    mapData: data => ({ ...data, created_by: user?.id, paper_id: !!data?.paper_id ? data?.paper_id : null }),
    onFinish(results) {
      const { errored, succeeded } = results
      if (errored?.length > 0) {
        notification.error({
          message: 'Error Occured',
          description: `${errored?.[0]?.request?.length} registrations data could not be uploaded`,
          duration: 5,
        })
      }
      if (succeeded?.length > 0) {
        notification.success({
          message: 'Successfully Uploaded',
          description: `${succeeded?.[0]?.response?.length} registrations data were uploaded`,
          duration: 5,
        })
      }
      console.log('ONFINISH RESULTSS', results)
    },
  })

  const { tableQueryResult, tableProps } = useTable<ICandidateRegistration>({
    resource: 'candidate_registration',
    metaData: registrationMetaData,
    queryOptions: { enabled: !!testEvent?.id },
    permanentFilter: [{ field: 'test_event_id', operator: 'eq', value: testEvent?.id }],
    initialSorter: [{ field: 'created_at', order: 'desc' }],
  })
  const listOfCandidates = tableQueryResult?.data?.data

  //components

  return (
    <List
      title="List of Registrations"
      headerButtons={
        <Space>
          <ImportButton {...importProps} />
          <Button type="primary" onClick={() => assignPaperModalShow()}>
            Assign Paper To Candidates
          </Button>
        </Space>
      }
    >
      <Table {...tableProps} rowKey={'id'} dataSource={listOfCandidates} size="small">
        <Table.Column
          title="User ID"
          dataIndex="user_id"
          render={(value, record, index) => (
            <Text strong code>
              {value}
            </Text>
          )}
        />
        <Table.Column
          title="Registration Id"
          dataIndex={'registration_id'}
          render={(value, record) => (
            <Text strong code>
              {value}
            </Text>
          )}
        />
        <Table.Column
          // colSpan={1}
          title="Name"
          render={(_, record: any) => {
            const firstName = record?.candidate_details?.first_name
            const lastName = record?.candidate_details?.last_name
            return <Text ellipsis={{ tooltip: `${firstName}${' '}${lastName}` }}>{firstName}</Text>
          }}
        />
        <Table.Column title="Test Track" render={(_, record: any) => <Text>{record?.test_track?.name}</Text>} />
        <Table.Column
          title="Exam Slot"
          render={(_, record: any) => {
            return (
              <Space>
                <Tag>
                  <DateField value={record?.date} format="LL" />
                </Tag>
                <Tag>
                  <Space>
                    <DateField value={record?.start_time} format="LT" />
                    <Text>To</Text>
                    <DateField value={record?.end_time} format="LT" />
                  </Space>
                </Tag>
              </Space>
            )
          }}
        />
        <Table.Column
          title="Paper Assigned"
          dataIndex="paper_id"
          render={(_, record: any) => {
            if (record?.paper_id !== undefined && record?.paper_id !== null) {
              let paperText = `#${record?.paper?.paper_id} ${record?.paper?.paper_smart_id}`
              return <Text>{paperText}</Text>
            }
            if (record?.paper_id === undefined || record?.paper_id === null)
              return (
                <Text type="danger" strong>
                  Not Assigned
                </Text>
              )
          }}
        />
      </Table>
      <AssignPaperToCandidates
        candidateList={listOfCandidates}
        testEvent={testEvent}
        modalProps={assignPaperModalProps}
        close={assignPaperModalClose}
        newPapers={newPapers}
        oldPapers={oldPapers}
        testTrackList={testTrackList}
      />
    </List>
  )
}

export default TestEventCandidates
